/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js";

const Content = (props) => {
  const { setShowModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <div className={classes.modalContent}>
      <div className={classes.btnContainer}>
        <UCButton
          className={classes.closeBtn}
          onClick={() => setShowModal(false)}
          type="primary"
          text={<FormattedMessage id="tierRequiredModal.close" />}
        />
      </div>
    </div>
  );
};

export default Content;
